import React, { useState } from "react";
import PropTypes from "prop-types";
import { Field, formValueSelector, change } from "redux-form";
import { connect } from "react-redux";
import { Col } from "react-bootstrap";
import {
  form,
  Form as AppForm,
  Select,
  FormRow,
  FormInput
} from "MODULES/shared/components/Forms";
import { resolveDiscrepancy } from "MODULES/Receiving/actions";
import {
  REASON_FOR_RESOLUTION,
  REASON_FOR_RESOLUTION_OPTIONS
} from "MODULES/Receiving/constants";
import { properCase } from "LIB/formatters/text";
import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import { arrayToOptions } from "LIB/forms";

const formName = "resolveDiscrepancy";
const REASON_FOR_RESOLUTION_OTHER = "reason_for_resolution_other";

export function Form(props) {
  const { closeResolveModal, setFieldValue } = props;
  const [displayField, setDisplayField] = useState(false);

  const handleChange = ev => {
    const target = ev.target.value;
    if (target === "Other") {
      setDisplayField(true);
    }
    if (target !== "Other") {
      setDisplayField(false);
    }
  };

  const addResolveResolutionOther = () => {
    if (props.getFieldValue(REASON_FOR_RESOLUTION) === "Other") {
      setFieldValue(REASON_FOR_RESOLUTION)(
        props.getFieldValue(REASON_FOR_RESOLUTION_OTHER)
      );
    }
  };

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormRow>
          <Col md={12}>
            <Field
              name={REASON_FOR_RESOLUTION}
              component={Select}
              label={properCase(REASON_FOR_RESOLUTION)}
              options={arrayToOptions(REASON_FOR_RESOLUTION_OPTIONS)}
              onChange={handleChange}
            />
            {displayField && (
              <Field
                name={REASON_FOR_RESOLUTION_OTHER}
                component={FormInput}
                required
                placeholder="Please fill out this field...."
                label={properCase(REASON_FOR_RESOLUTION)}
              />
            )}
          </Col>
        </FormRow>
      </AppForm.Body>
      <AppForm.Footer>
        <FormRow>
          <Col md={12}>
            <button
              type="button"
              className="btn btn-default"
              onClick={closeResolveModal}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              onClick={addResolveResolutionOther}
            >
              <i className="fa fa-warning" />
              &nbsp;Yes, Resolve Discrepancy
            </button>
          </Col>
        </FormRow>
      </AppForm.Footer>
    </AppForm>
  );
}

Form.propTypes = {
  closeResolveModal: PropTypes.func.isRequired,
  initialValues: PropTypes.shape({
    id: PropTypes.number.isRequired,
    reason_for_resolution: PropTypes.string
  }),
  setFieldValue: PropTypes.func.isRequired
};

const selector = formValueSelector(formName);

export default connect(
  state => ({
    getFieldValue: field => selector(state, field)
  }),
  dispatch => ({
    onSubmit: data => dispatch(resolveDiscrepancy(data)),
    setFieldValue: field => val => dispatch(change(formName, field, val))
  })
)(
  form({
    form: formName,
    validate: values =>
      validator(values, f => {
        f.validate(REASON_FOR_RESOLUTION).satisfies(rules.required);
        f.validate(REASON_FOR_RESOLUTION_OTHER).satisfies(rules.required);
      })
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/Receiving/Detail/Discrepancies/ResolveForm.jsx